import React, {useMemo, useRef, useState} from "react";
import {Outlet, useOutletContext, useParams, useSearchParams} from "react-router-dom";
import UserDiscipline from "../../models/UserDiscipline";
import {useAPI} from "../../config/API";
import {TalentProfile} from "../profiles/TalentProfilePage";
import PageError from "../../components/errors/PageError";
import LoadingBanner from "../../components/LoadingBanner";
import WrippleHelmet from "../../components/WrippleHelmet";

const disciplineCategories = TB.map([...laravel.discipline_categories], cat => {
    let option = TB.pick(cat, ['id', 'name', 'disciplines', 'display_order'])
    let disciplines = option.disciplines;//TB.filter(option.disciplines, ['is_contractable', true]);

    option.disciplines = TB.map(disciplines, discipline => TB.pick(discipline, ['id', 'name', 'display_order']))
    option.value = option.id;

    return option
});


const disciplines = TB.map(disciplineCategories, category => {
    return {
        ...category,
        options: category.disciplines.map(discipline => {
            return {
                ...discipline,
                value: discipline.id
            }
        })
    }
})
const talentBrands = TB.map([...laravel.talent_brands], brand => {
    return {
        ...brand,
        value: brand.id
    }
})

const industries = TB.map(laravel.client_industries, (name, value) => {
    return {name, value: Number(value), id: Number(value)}
});

const LOCAL_STORAGE_KEY = TB.storedBrowseFilters('talent');

const BrowseTalentLayout = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const decodedSearchParams = useMemo(() => {
        return [...searchParams.entries()].reduce((acc, [key, val]) => {
            return { ...acc, [key]: val };
        }, {});
    }, [searchParams?.toString()]);

    const hasSetRequiredFilters = useMemo(() => {
        let selectedDisciplines = TB.flatMap(
            TB.map(TB.filter(decodedSearchParams, (value, key) => key.includes('disciplines')), dis => {
                try {
                    return JSON.parse(dis)
                } catch {
                    return dis
                }
            })
        )
        return selectedDisciplines?.length > 0;
    }, [searchParams?.toString()]);

    const [selectedTalent, setSelectedTalent] = useState(null);
    const addToProjectModal = useRef(null);

    const { data: searchData, isFetching: isSearchLoading, error } = useAPI([
        'searchForTalent', { sort_by: 'best_match',...decodedSearchParams }], {
        enabled: searchParams.toString()?.length > 0 && hasSetRequiredFilters,
        keepPreviousData: true,
        onSuccess: (response) => {
            if(response?.users?.length > 0) {
                // let stored = {};
                // TB.map(decodedSearchParams, (value, key) => {
                //     stored[key] = JSON.parse(value)
                // })
                // TB.persistStoredBrowseFilters("talent", stored)
            }
        }
    })


    const criteriaForMatching = useMemo(() => {
        const currentParams = Object.fromEntries([...searchParams]);

        if (!Object.keys(currentParams)?.length) return null;

        let criteria = {};
        TB.map(currentParams, (value, key) => {

            if (key.includes('disciplines')) {
                let roleIds = JSON.parse(value) || [];

                roleIds = TB.filter(roleIds, role => !TB.isNaN(parseInt(role)))
                let roles = TB.filter(TB.flatMap(disciplines, 'options'), dis => roleIds.includes(dis.id));
                criteria.disciplines = TB.uniqBy([
                    ...(criteria.disciplines || []),
                    ...roles
                ], 'id');

                // let scorePrefix = TB.replace(key, '_disciplines', '');
                // if (scorePrefix && TB.find(experienceLevels, ['prefix', scorePrefix])) {
                //     criteria.min_score = TB.find(experienceLevels, ['prefix', scorePrefix])?.value;
                // }
            }
            if (key.includes('brands')) {
                let brandIds = JSON.parse(value) || [];

                console.log('brands', brandIds)
                brandIds = TB.filter(brandIds, brandId => !TB.isNaN(parseInt(brandId)))
                let brands = TB.filter(talentBrands, brand => brandIds.includes(brand.id));
                criteria.brands = TB.uniqBy([
                    ...(criteria.brands || []),
                    ...brands
                ], 'id');

                console.log('brands', brandIds)
                // let scorePrefix = TB.replace(key, '_disciplines', '');
                // if (scorePrefix && TB.find(experienceLevels, ['prefix', scorePrefix])) {
                //     criteria.min_score = TB.find(experienceLevels, ['prefix', scorePrefix])?.value;
                // }
            }

            if (key.includes('skills')) {
                let skillIds = JSON.parse(value) || [];
                skillIds = TB.filter(skillIds, skill => !TB.isNaN(parseInt(skill)))
                const skillsByRole = UserDiscipline.skillsForDisciplines(TB.map(TB.flatMap(disciplines, 'options'), 'id')) || [];
                let skills = TB.filter(skillsByRole, skill => skillIds.includes(skill.id));
                let scorePrefix = TB.replace(key, 'skills', '');

                criteria[`${scorePrefix}skills`] = TB.uniqBy([
                    ...(criteria[`${scorePrefix}skills`] || []),
                    ...skills
                ], 'id')
            }else if (key.includes('industries')) {
                let industriesIds = JSON.parse(value) || [];

                industriesIds = TB.filter(industriesIds, industry => !TB.isNaN(parseInt(industry)))
                let industriesSearch = TB.filter(industries, industry => industriesIds.includes(industry.id));
                let scorePrefix = TB.replace(key, 'industries', '');

                criteria[`${scorePrefix}industries`] = TB.uniqBy([
                    ...(criteria[`${scorePrefix}industries`] || []),
                    ...industriesSearch
                ], 'id')
            }
            if (key === 'experience') {
                try {
                    let experience = JSON.parse(value);
                    criteria['experience'] = experience;
                    TB.map(experience, (isChecked, expType) => {
                        criteria[expType] = isChecked;
                    })
                }catch (e) {
                    console.warn('jsonError', e)
                }
            }

            if (key === 'hired') {
                criteria.hired = JSON.parse(value)
            }

            if (key === 'favorited') {
                criteria.favorited = JSON.parse(value)
            }
            if (key === 'invited') {
                criteria.invited = JSON.parse(value)
            }
            if (key === 'pool_ids') {
                criteria.pool_ids = JSON.parse(value)

                criteria.pool_ids = TB.filter(criteria.pool_ids, pool => !TB.isNaN(parseInt(pool)))
            }

            if (key === 'location' && !TB.isNaN(parseInt(JSON.parse(value)))) {
                criteria.location = parseInt(JSON.parse(value))
            }
            if (key === 'regions') {
                criteria.regions = JSON.parse(value)

                criteria.regions = TB.filter(criteria.regions, regionId => !TB.isNaN(parseInt(regionId)))
            }
            if (key === 'latitude' && !TB.isNaN(parseFloat(JSON.parse(value)))) {
                criteria.latitude = parseFloat(JSON.parse(value))
            }
            if (key === 'longitude' && !TB.isNaN(parseFloat(JSON.parse(value)))) {
                criteria.longitude = parseFloat(JSON.parse(value))
            }
        })
        return criteria;
    }, [searchParams?.toString()]);

    return (
        <React.Fragment>
            <WrippleHelmet title="Browse Talent" />

            <Outlet context={{
                searchData,
                hasSetRequiredFilters,
                error,
                criteriaForMatching,
                isSearchLoading
            }}/>

        </React.Fragment>
    )
}


const BrowseTalentProfile = (props) => {
    const {
        searchData,
        hasSetRequiredFilters,
        error,
        criteriaForMatching,
        isSearchLoading
    } = useOutletContext();

    const {profileId} = useParams();

    if (isSearchLoading) {
        return (
            <div className="flex-grow w-full h-full mx-auto">
                <LoadingBanner/>
            </div>
        )
    }
    if (TB.isNaN(parseInt(profileId)) || error || !searchData?.users?.length) {
        return (
            <div className="flex-grow w-full h-full mx-auto">
                <PageError/>
            </div>
        )
    }

    console.log('BrowseTalentProfile', criteriaForMatching)
    return (
        <TalentProfile
            criteria={criteriaForMatching}
            browseResults={searchData?.users}/>
    )
}
export {
    BrowseTalentProfile
}
export default BrowseTalentLayout;